
import * as React from 'react';
import { connect } from 'react-redux';
import { createConnector } from 'react-redux-idle-monitor';

const connectIdleMonitor = createConnector({ connect });

// interface ComponentProps {
//     idleStatus: any;
//     isIdle: any,
//     isPaused: any,
//     isDetectionRunning: any,
//     lastActive: any,
//     lastEvent: any,
//     // render: any,
// }

class IdleMonitorProvider extends React.Component/*<ComponentProps, {}>*/ {
    // public static defaultProps: Partial<ComponentProps> = {
    //     idleStatus: null,
    //     isIdle: null,
    //     isPaused: null,
    //     isDetectionRunning: null,
    //     lastActive: null,
    //     lastEvent: null,
    //     // render: () => {},
    // };

    render() {
        const { idleStatus, isIdle, isPaused, isDetectionRunning, lastActive, lastEvent } = this.props;
        const idleMonitor = {
            idleStatus,
            isIdle,
            isPaused,
            isDetectionRunning,
            lastActive,
            lastEvent
        }
        //console.log('IDLE STATUS:', idleMonitor.idleStatus)
        return this.props.render(idleMonitor) || null;
    }
}

export default connectIdleMonitor/*<ComponentProps>*/(IdleMonitorProvider);


// WEBPACK FOOTER //
// ./src/IdleMonitorProvider.js